import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { REACT_APP_API_URL } from '../../../env';

export const fetchBlockingHistory = createAsyncThunk(
  'blockings/fetchBlockingHistory',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/hotel-blocking/history`, {
        params,
        withCredentials: true,
      });
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message || 'Failed to fetch blocking history');
    }
  }
);

export const fetchManagerBlockingHistory = createAsyncThunk(
  'blockings/fetchManagerBlockingHistory',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${REACT_APP_API_URL}api/dashboard/admin/manager/hotel-blocking/history`,
        {
          params,
          withCredentials: true,
        },
      );
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message || 'Failed to fetch manager blocking history');
    }
  }
);


const blockingsSlice = createSlice({
  name: 'blockings',
  initialState: {
    data: [],
    status: 'idle',
    error: null,
  },
  reducers: {
    clearBlockings: (state) => {
      state.data = [];
      state.error = null;
      state.status = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlockingHistory.pending, (state) => {
        state.status = 'pending';
        state.error = null;
      })
      .addCase(fetchBlockingHistory.fulfilled, (state, action) => {
        state.status = 'fulfilled';
        state.data = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchBlockingHistory.rejected, (state, action) => {
        state.status = 'rejected';
        state.error = action.payload || 'Failed to fetch room blockings';
      })
      .addCase(fetchManagerBlockingHistory.pending, (state) => {
        state.status = 'pending';
        state.error = null;
      })
      .addCase(fetchManagerBlockingHistory.fulfilled, (state, action) => {
        state.status = 'fulfilled';
        state.data = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchManagerBlockingHistory.rejected, (state, action) => {
        state.status = 'rejected';
        state.error = action.payload || 'Failed to fetch manager room blockings';
      });
  },
});

export const { clearBlockings } = blockingsSlice.actions;
export default blockingsSlice.reducer;
